const messages = {
  emailExists: 'Mailadressen används redan.',
  mustBeSixChars: 'Koden måste vara 6 tecken lång.',
  subdomainInUse: 'Webbadressen används redan.',
  joi: {
    must_be_a_valid_email: 'Mailadressen är inte giltig.',
    length_must_be_less_than_or_equal_to_100_characters_long:
      'Fältet får inte vara längre än 100 tecken.',
    password_failed_validation: 'Lösenordet uppfyller inte kraven.',
  },
}

export type MessageKey = keyof typeof messages

export const message = (path: MessageKey): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let message: any = messages
  path.split('.').forEach((key) => {
    message = message[key as keyof typeof message]
  })
  return (message as unknown as string) || path
}
